<span *ngIf="member">
    <div class="govuk-width-container">
        <div class="govuk-width-container">
            <div class="govuk-grid-column wrapper wrap">
                <div class="header-tabbing">
                    <span>Welcome {{name}}</span>
                    <a (click)="logout()" tabindex="0" class="float-right logout-link">{{'MEMBER_BAR.LOGOUT' |
                        translate}}</a>
                    <span class="float-right mr-1 ml-1" style="padding-left: 5px;padding-right: 5px;"> | </span>
                    <a tabindex="0" *ngIf="currentLink === '/account'" routerLink="/departments"
                        class="float-right">{{'MEMBER_BAR.JOURNEY_LINK' | translate}}</a>
                    <a tabindex="0" *ngIf="currentLink !== '/account'" routerLink="/account"
                        class="float-right">{{'MEMBER_BAR.MY_ACCOUNT_LINK' | translate}}</a>
                </div>
            </div>
            <div class="govuk-grid-column wrapper wrap" style="text-align: center;">
                Click on 'My account' to update your details and manage your bookings.
            </div>
        </div>
    </div>
    <hr class="mt-2 mb-2 member-bar-seperator" />
</span>